"use client";

import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import React from "react";
import "./DevelopmentPartner.scss";
import Image from "next/image";

const DevelopmentPartner = ({ data }) => {
  return (
    <section className="development-partner-section">
      <Container>
        {/* TOP CONTENT */}
        <Row className="top-wrapper">
          <Col lg={6}>
            <h2 className="section-title">{data.heading}</h2>
          </Col>

          <Col lg={5} className="ms-auto">
            <p className="section-description">
            {data.description}
            </p>
          </Col>
        </Row>

        {/* MAIN GRID */}
        <Row className="content-wrapper align-items-stretch">
          {/* LEFT CARD */}
          <Col lg={4} className="mb-4 mb-lg-0">
            <div className="feature-card">
              {data?.features?.map((item, index) => (
                <div key={index} className="feature-item">
                 
                    <span className="dot"></span>
                      <div className="feature-content">
                    <h4>{item.title}</h4>
                    <p>{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </Col>

          {/* RIGHT IMAGE */}
          <Col lg={8}>
            <div className="image-wrapper">
              <div className="top-badge">
                {data?.floatfeatures?.map((item, index) => (
                  <React.Fragment key={index}>
                    <div className="badge-item">

                       <span className="dot"></span>
                      <div className="badge-content">
                        <h5>{item.title}</h5>
                        <p>{item.description}</p>
                      </div>
                    </div>

                    {index !==
                      data?.developmentpartner?.floatfeatures?.length - 1 && (
                      <div className="divider" />
                    )}
                  </React.Fragment>
                ))}
              </div>

              <Image
                src={data.image}
                alt="Project Execution"
                className="main-image"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default DevelopmentPartner;
